<template>
  <div class="p-2 text-2xl">Team Picker Action goes here...</div>
</template>
